import React from 'react';

interface SEOHeadingProps {
  level: 1 | 2 | 3 | 4 | 5 | 6;
  children: React.ReactNode;
  className?: string;
  id?: string;
}

const SEOHeading = ({ level, children, className = '', id }: SEOHeadingProps) => {
  const Tag = `h${level}` as keyof JSX.IntrinsicElements;

  const baseStyles = 'font-heading text-foreground';
  
  const levelStyles = {
    1: 'text-[2.75rem] leading-[1.15] font-bold md:text-[2rem]',
    2: 'text-[2.25rem] leading-[1.2] font-semibold md:text-[1.75rem]',
    3: 'text-[1.75rem] leading-[1.25] font-semibold md:text-[1.5rem]',
    4: 'text-[1.375rem] leading-[1.3] font-semibold',
    5: 'text-[1.125rem] leading-[1.4] font-medium',
    6: 'text-base leading-[1.4] font-medium',
  };

  return (
    <Tag 
      id={id}
      className={`${baseStyles} ${levelStyles[level]} ${className}`}
    >
      {children}
    </Tag>
  );
};

export default SEOHeading;